import { Action } from '@ngrx/store';
import { INTERCOM_BOOT, INTERCOM_SHUTDOWN } from '../action-types';

export class BootIntercomAction implements Action {
    readonly type = INTERCOM_BOOT;
}

export class ShutdownIntercomAction implements Action {
    readonly type = INTERCOM_SHUTDOWN;
}